
import React from 'react';
import { Globe, ShoppingCart, Target, Megaphone, Video, Users } from 'lucide-react';

const NewServicesSection = () => {
  const services = [
    {
      icon: <Globe className="w-6 h-6" />,
      title: "Δημιουργία ιστοσελίδων σε 24–48 ώρες",
      description: "Γρήγορη και αποτελεσματική κατασκευή professional ιστοσελίδων"
    },
    {
      icon: <ShoppingCart className="w-6 h-6" />,
      title: "Shopify eShop καταστήματα με SEO, πληρωμές & αυτοματισμούς",
      description: "Ολοκληρωμένα online καταστήματα έτοιμα για πωλήσεις"
    },
    {
      icon: <Target className="w-6 h-6" />,
      title: "Funnels & landing pages που μετατρέπουν",
      description: "Σελίδες προορισμού με υψηλά ποσοστά μετατροπής"
    },
    {
      icon: <Megaphone className="w-6 h-6" />,
      title: "Meta & TikTok Ads",
      description: "Στρατηγικές διαφήμισης που φέρνουν αποτελέσματα"
    },
    {
      icon: <Video className="w-6 h-6" />,
      title: "Παραγωγή Social Media περιεχομένου (βίντεο, script, visuals)",
      description: "Δημιουργικό περιεχόμενο που εμπλέκει το κοινό"
    },
    {
      icon: <Users className="w-6 h-6" />,
      title: "Στρατηγική & Συμβουλευτική για digital ανάπτυξη",
      description: "Καθοδήγηση για μακροπρόθεσμη online επιτυχία"
    }
  ];

  return (
    <section className="py-32 bg-gradient-to-b from-dark-200 to-black">
      <div className="container mx-auto px-6 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-20">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
              Υπηρεσίες
            </h2>
            <p className="text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed">
              Ο Mike Foto παρέχει επιλεγμένες υπηρεσίες για επιχειρηματίες που χρειάζονται ξεκάθαρη online παρουσία.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div 
                key={index}
                className="group bg-gradient-to-br from-dark-300 to-dark-400 rounded-xl p-8 hover:from-dark-400 hover:to-dark-500 transition-all duration-500 hover:scale-105 hover:shadow-xl animate-fade-in-up border border-gray-800 hover:border-gray-600"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-brand rounded-lg flex items-center justify-center text-white group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    {service.icon}
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-white mb-3 leading-snug">
                      {service.title}
                    </h3>
                    <p className="text-gray-400 text-sm leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewServicesSection;
